export default {
  movieList(state, {movieList}) {
    state.movieList = movieList;
  },
  selectedMovie(state, {movie}) {
    state.selectedMovie = movie;
  },
  setSelectedShow(state, show) {
    state.selectedShow = show;
  },

  availableTimes(state, {availableTimes}) {
    state.availableTimes = availableTimes;
  },
  availableDays(state, {availableDays}) {
    state.availableDays = availableDays;
  },
  availableRange(state, {availableRange}) {
    state.availableRange = availableRange;
  }
}
